import { useEffect, useRef } from 'react';

export const useBehaviorForAddressFields = (countryCode, stateCode, stateFieldName, cityFieldName, form) => {
  const prevCountryCode = useRef(countryCode);
  const prevStateCode = useRef(stateCode);

  useEffect(() => {
    if (form && prevCountryCode.current !== countryCode) {
      form.setFieldsValue({ [stateFieldName]: null, [cityFieldName]: null });
      prevCountryCode.current = countryCode;
    }
  }, [countryCode, stateFieldName, cityFieldName, form]);

  useEffect(() => {
    if (form && prevStateCode.current !== stateCode) {
      form.setFieldsValue({ [cityFieldName]: null });
      prevStateCode.current = stateCode;
    }
  }, [stateCode, cityFieldName, form]);
};
